import * as React from "react";
import siteConfig from "site-config";
import _ from "lodash";

interface IProps {
    value: string | number;
}

export const RatingsRenderer: React.SFC<IProps> = ({ value }) => {
    const numberValue = Number(value) || 0;
    const src = `${siteConfig.assetPath}/images/collections/star.svg`;
    const stars = _.times(5, (i) =>
        numberValue <= i ? null : <img key={i} src={src} className="star" width="12" height="12" />
    );

    return <span>{stars}</span>;
};
